/**
 * Adressen normalisieren.
 *
 * Bewusst getrennt von `id.ts`: Dort steckt `createId` und damit
 * `node:crypto`. Was mit Adressen zu tun hat, wird auch in der Oberfläche
 * gebraucht — und ein Wertimport, der `node:crypto` nach sich zieht, ist im
 * Browser-Bundle nicht zu gebrauchen.
 */

/** Normalisiert eine E-Mail für Dedupe und Sperrlisten-Vergleich. */
export function normalizeEmail(email: string | null | undefined): string | null {
  if (!email) return null;
  const trimmed = email.trim().toLowerCase();
  return trimmed.length > 0 ? trimmed : null;
}

/** Extrahiert die Domain aus einer E-Mail-Adresse. */
export function emailDomain(email: string | null | undefined): string | null {
  const norm = normalizeEmail(email);
  if (!norm) return null;
  const at = norm.lastIndexOf('@');
  return at > 0 ? norm.slice(at + 1) : null;
}
